
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipients",
      function () {
        return require("private-next-pages/recipients.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipients"])
      });
    }
  